var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('h1',{staticClass:"text-h2 mb-4"},[_vm._v("Список КР для оценки")]),_c('QuestionList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }